/// <reference path="global.d.ts" />

import '../style/gf-pdf-generator.scss';

import {disableButtons, enableButtons, setupBatchMenu} from './batch-menu';

import './preprinted';
import {addEmailButton} from './email';
import './action-selector';
import {addActionCardsButton} from './action-selector';
import {createDialog} from './dialog';
import {displayLayoutOptionsDialog} from './layout-selector';
import {renderEnterCertificateNumberDialog, renderTestPrintBlockDialog} from './preprinted';
import {displayNoPreviewWarningDialog} from './preview';
import {generatePDFUrl, triggerDownload} from './helpers';
import {markReloadPendingOnReturn} from './datatable';

// @ts-ignore
let $ = window.jQuery;

function toggleButtons() {
    if ($('input[name="entries[]"]:checked').length > 0) {
        enableButtons();
    } else {
        disableButtons();
    }
}

jQuery(function ($) {
    const $body = $('body');
    if ($('.gv-checkbox-select-all').length > 0) {
        setupBatchMenu();

        addEmailButton();
        addActionCardsButton();

        toggleButtons();

        $body.on('gv_datatables_reloaded', toggleButtons);

        $body
            .on('change', 'input[name="entries[]"]', toggleButtons)
            .on('click', '.gv-checkbox-select-all', function () {
                $(this).closest('table').find('input[type=checkbox]').prop('checked', $(this).prop('checked')).trigger('change');
            });
    }

    $body.on('pdfAction', function (e, action: PDFAction, entryIds: number[], preselectedLayoutId?: string) {
        if (action.trigger_custom_event) {
            $body.trigger(action.key, [action, entryIds, preselectedLayoutId]);
            return;
        }

        let doAction = function (layoutId = 'default') {
            markReloadPendingOnReturn();
            triggerDownload(generatePDFUrl(action, entryIds, layoutId));
        }

        if (action.collect_serial) {
            doAction = function (layoutId = 'default') {
                renderEnterCertificateNumberDialog(entryIds, action);
            }
        }

        let nextCallback = function (layoutId: string) {
            if (action.display_preview_warning) {
                displayNoPreviewWarningDialog(action, entryIds, layoutId, () => doAction(layoutId));
            } else {
                doAction(layoutId);
            }
        }

        let next: () => void;
        const hasLayouts = action.supports_layouts && PDFGeneratorFormSettings.pdf_layout.length > 0;
        if (hasLayouts && !preselectedLayoutId) {
            next = () => displayLayoutOptionsDialog(nextCallback);
        } else {
            next = () => nextCallback(preselectedLayoutId ?? (action.use_blank_template ? 'blank' : 'default'));
        }

        if (action.display_test_print) {
            renderTestPrintBlockDialog(next, entryIds, preselectedLayoutId ?? 'default');
        } else {
            next();
        }
    });

    // Change data tables filter to match the certificates being created.
    $body.on('change', '.event-date-source input', function () {
        const number = $(this).attr('name').match(/\d+/)[0];
        const date = $(this).val();
        const filter = $(`#search-box-filter_${number}`);
        filter.val(date);
        filter.closest('form').trigger('submit');
    });

    // Hide the search box on the certificates page.
    const collapseSearch = $('.gf-pdf-collapse-search');
    if (collapseSearch.length > 0) {
        const triggerSearch = $(`<button class="gf-pdf-trigger-search gf-pdf-button -light">${PDFGenerator.text_show_search}</button>`);
        const searchWidget = $('.gv-widget-search');

        const updateSearchWidgetButton = function (expanded) {
            if (expanded) {
                triggerSearch.html(PDFGenerator.text_hide_search);
            } else {
                triggerSearch.html(PDFGenerator.text_show_search);
            }

            collapseSearch.append(
                triggerSearch
            );
        }

        let dirty = false;
        for (let input of $<HTMLInputElement>('input[type="text"],select', searchWidget).toArray()) {
            if (input.value !== '') {
                dirty = true;
            }
        }

        if (!dirty) {
            searchWidget.hide();
        }
        updateSearchWidgetButton(dirty);

        triggerSearch.on('click', function () {
            if (searchWidget.is(':hidden')) {
                searchWidget.slideDown();
                updateSearchWidgetButton(true);
            } else {
                searchWidget.slideUp();
                updateSearchWidgetButton(false);
            }
        });
    }

    $body.on('click', '.gf-pdf-show-entry-history', function () {
        const entryId = $(this).data('entry-id');
        // Responsive datatables can move the history element around,
        // so we make sure we select the closest one.
        const parent = $(this).parent()
        const modalContent: JQuery<HTMLDivElement> = $(`#gf_pdf_history_${entryId}`, parent);

        const dialog = createDialog('<span class="gf-pdf-button -small -cancel gf-pdf-modal-close">close</span>', modalContent.html());
        dialog[0].showModal();
        dialog.on('close', function () {
            dialog.remove();
        });
    });
});